
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import FormService from "@/services/FormService";

@Component
export default class PhoneInput extends Vue {
  @Prop({ default: "" })
  value!: string;

  @Prop({ default: "" })
  label!: string;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: false })
  rounded!: boolean;

  phone = this.value;

  isInvalid = false;

  countryDialCode = "";

  phoneRules = [FormService.phoneNumberFormatRule];

  loading = false;

  @Prop({ default: "" })
  countryCode!: string;

  @Watch("value")
  updatePhone() {
    this.phone = this.value;
  }

  /* very important, to allow editing existing phone number */
  get inputIsEmpty() {
    return this.value === "" || this.value == null;
  }

  /* only updates value on blur, prevents the phone being set to just a country code */
  onChange() {
    if (
      this.phone.length === 0 ||
      (this.countryDialCode !== "" &&
        this.phone !== "+" + this.countryDialCode &&
        this.phone.length > 4 &&
        this.phone !== this.value)
    ) {
      this.isInvalid = false;
      if (this.phone.match(/[()-]|\s{2,}/)) {
        this.phone = FormService.formatPhoneNumber(this.phone);
      }
      this.$emit("input", this.phone);
      this.$emit("phone-number-changed");
    } else if (this.countryDialCode !== "" && this.phone.length <= 4) {
      this.isInvalid = true;
    }
  }

  /* important, used to check if the phone number is just a country code */
  onCountryChange(newCountry: any) {
    this.countryDialCode = newCountry.dialCode;
    if (!this.phone.match("^\\+" + this.countryDialCode + ".*"))
      this.$emit("input", "");
  }
}
